'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './residential_uses.routes';

export class ResidentialUsesComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $http, baseConfigService, $stateParams, $timeout) {
    const vm = this; // Store reference to 'this'
    this.$scope = $scope;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$state = $state;
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$http = $http;

    $scope.submitDensityForReview = false;
    $scope.savemode = null;
    $scope.densityType = 'Residential';
    $scope.pendingAverage = false;
    $scope.updateData = [];
    $scope.showTierOverride = false;

    $scope.attachmentData = $scope.attachmentData || {};
    $scope.submissions = [];
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.adminUnlocked = false; // track admin manual unlock
    $scope.residentialUsesCheck = false;
    $scope.submitmode = null;
    $scope.initialLoad = true;

    $scope.density = {};

    $scope.policy_name = 'Residential Uses Data Verification'


    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };
    
    $scope.scrollToTop = function() {
      window.scrollTo(0, 0);
    };

    $scope.residential_density_no_changes_checked = false;
    $scope.residential_density_table_changes_checked = false;

    $scope.setPending = function () {
      console.log('set pending ran')
      console.log($scope.initialLoad);
      if(!$scope.initialLoad){
        $scope.savemode = 'validation'
        $scope.pendingChanges = true;
      }
    }

    $scope.tier4Corridors = [
      "Bayshore Caltrain",
      "Orinda BART",
      "Lafayette BART",
      "Belmont Caltrain",
      "San Carlos Caltrain"
    ];

    $scope.thresholds = [
      {
        'tier': '1',
        'threshold': {
          toc_min_dua: 100,
          toc_max_dua: 150,
          toc_min_far: 4,
          toc_max_far: 8
        }
      },
      {
        'tier': '2',
        'threshold': {
          toc_min_dua: 75,
          toc_max_dua: 100,
          toc_min_far: 3,
          toc_max_far: 6
        }
      },
      {
        'tier': '3',
        'threshold': {
          toc_min_dua: 50,
          toc_max_dua: 75,
          toc_min_far: 2,
          toc_max_far: 4
        }
      },
      {
        'tier': '4',
        'threshold': {
          toc_min_dua: 25,
          toc_max_dua: 35,
          toc_min_far: 1,
          toc_max_far: 3
        }
      }
    ]

        $scope.isFormEditable = function () {
      if (!$scope.currentDensityPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;
      // Find matching submission status for current policy
      var submission = null;
      if ($scope.stationStatus) {
        for (var i = 0; i < $scope.stationStatus.length; i++) {
          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
            submission = $scope.stationStatus[i];
            break;
          }
        }
      }      
      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;

      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }
      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentDensityPolicy
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.stationStatus && $scope.policy_name) {
          var sub = _.find($scope.stationStatus, { submission_policy_name: $scope.policy_name });
          if (sub && sub.submitted && sub.status === 'Needs Work') { $scope.needsWorkNotice = true; }
        }
      }
    );

    $scope.$watch('stationStatus', function () {
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

    $scope.withdrawSubmission = function () {
      var confirmWithdraw = window.confirm(
        "Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.",
      );
      if (!confirmWithdraw) return;

      var submission = null;
      if ($scope.stationStatus) {
        for (var i = 0; i < $scope.stationStatus.length; i++) {
          if (
            $scope.stationStatus[i].submission_policy_name ===
            $scope.policy_name
          ) {
            submission = $scope.stationStatus[i];
            break;
          }
        }
      }

      if (!submission || !submission.submission_id) {
        console.error("No matching submission found to withdraw");
        return;
      }

      var payload = {
        submission_id: submission.submission_id,
        submitted: false,
        status: null,
      };

       fetch.updateItem('api/data/submissions/update-status', payload)
    .then(function () {
      submission.submitted = false;
      submission.status = null;

       if ($scope.policy_name === 'Residential Uses Data Verification') {
        $scope.residentialUsesCheck = false;
        $scope.density.residentialUsesCheck = false;
      } else if ($scope.policy_name === 'Commercial Office Uses Data Verification') {
        $scope.commercialUsesCheck = false;
        $scope.density.commercialUsesCheck = false;
      } else if ($scope.policy_name === 'Minimum Density Residential') {
        $scope.minDUA = false;
      } else if ($scope.policy_name === 'Maximum Density Residential') {
        $scope.maxDUA = false;
      }

      if (!$scope.minDUA && !$scope.maxDUA && !$scope.residentialUsesCheck && !$scope.commercialUsesCheck) {
        $scope.submitted = false;
      }

      $scope.submissions = $scope.submissions.filter(function (s) {
        return s.submission_id !== submission.submission_id;
      });

      if ($scope.submissions.length === 0) {
        $scope.submitmode = null;
      }

      // 3. Unlock form
      $scope.formReadOnly = false;

      // Clear form fields — preserve only identity fields
      var formId = $scope.currentDensityPolicy ? $scope.currentDensityPolicy.density_form_id : null;
      $scope.currentDensityPolicy = { density_form_id: formId };
      if ($scope.hot) { $scope.hot.loadData([]); }

      // Show withdrawn notification
      $scope.withdrawnNotice = true;
      $scope.needsWorkNotice = false;
      $scope.success = false;
    })
    .catch(function (err) {
      console.error('Withdraw failed:', err);
      alert('There was an error withdrawing the submission. Please try again.');
    });
};


    $scope.onResidentialCheckboxChange = function(type) {
      if (type === 'noChanges' && $scope.currentDensityPolicy.residential_density_no_changes_checked) {
        $scope.currentDensityPolicy.residential_density_table_changes_checked = false;
      }
      if (type === 'tableChanges' && $scope.currentDensityPolicy.residential_density_table_changes_checked) {
        $scope.currentDensityPolicy.residential_density_no_changes_checked = false;
      }
    };

  $scope.addToSubmissions = function (submission) {
    const index = $scope.submissions.indexOf(submission);
    if (index > -1) { // only splice array when item is found
      $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      $scope.submissions.push(submission);
    
    }
    console.log($scope.submissions)
    if ($scope.submissions.length > 0) {
      $scope.submitmode = 'density';
    } else {
      $scope.submitmode = null;
      
    }
  }

    /**
 * Get list of zoning codes by jurisdiction
 * @param {*} jurisdiction 
 */
    $scope.getZoningCodes = function (jurisdiction) {
      $scope.loadingTable = true;
      $scope.currentJurisdiction = jurisdiction;
      lookup.setJurisdiction($scope.currentJurisdiction);
      fetch.getAllItems(`api/data/density/zoning/${$scope.currentJurisdiction}`)
        .then(response => {
          $scope.znCodes = response.data;
          $scope.loadingTable = false;
          $scope.znCodes.forEach(element => {

            element.last_edited = moment(element.last_edited).format('L');
            if (element.zn_code_url) {
              element.zn_code_url = `<a href='${element.zn_code_url}' target='_blank'>${element.zn_code_url}</a>`;
            }
          });
          $scope.znCodes = _.orderBy($scope.znCodes, 'allows_residential', 'desc')
          $scope.loadTable($scope.znCodes);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    /**
     * Load handsontable based on zoning data returned for jurisdiction
     * @param {*} data 
     */
    $scope.loadTable = function (data) {
      const container = document.querySelector('#handsOnTable');
      data = data.filter(item => item.zn_recid !== null && item.zn_recid !== undefined);
      if ($scope.hot) {
        $scope.hot.loadData(data);
        $scope.hot.render();
      }
      else {
        $scope.hot = new Handsontable(container, {
          data,
          colHeaders: false, // Disable default column headers
          nestedHeaders: [
            [
              'ID',
              'Zoning ID',
              'Jurisdiction',
              'Zoning Code',
              'Description',
              'Allows <br> Residential',
              "Min DUA",
              "Max DUA",
              "Calculated Using <br> FAR or Height",
              "Acres <br> Within Zone",
              "Acres of Existing <br> Dwelling Units Excluded",
              "Documentation",
              "Last Edited",
              "Editor"

            ],
          ],
          allowInsertRow: true,
          manualColumnResize: true,
          height: 600,
          overflow: 'auto',
          autoWrapRow: true,
          rowHeaders: true,
          colWidths: [null, null, null, 40, 150, 50, 30, 30, 60, 60, 180],
          stretchH: 'all',
          filters: true,
          // contextMenu: true,
          dropdownMenu: [
            "filter_by_condition",
            "filter_by_value",
            "filter_action_bar",
          ],
          manualColumnMove: true, // enable moving columns
          manualColumnFreeze: true, // enable freezing columns
          manualColumnResize: true, // enable resizing columns
          multiColumnSorting: {
            indicator: true,
          },
          // colHeaders: [
          //   "ID",
          //   "Zoning ID",
          //   "Jurisdiction",
          //   "Zoning Code",
          //   "Description",
          //   "Allows Residential",
          //   "Min DUA",
          //   "Max DUA",
          //   "Acres Within Zone",
          //   "Acres of Existing Dwelling Units Excluded",
          //   "Documentation",
          //   "Last Edited",
          //   "Editor"],
          columns: [
            { data: 'rec_id' }, //Needs to be added to database
            { data: 'zn_recid' },
            { data: 'jurisdiction' },
            { data: 'zn_code' },
            { data: 'zn_description' },
            {
              data: 'allows_residential',
              type: "checkbox",
              className: "htCenter"
            },
            {
              data: 'toc_min_dua',
              type: 'numeric'
            },
            {
              data: 'toc_max_dua',
              type: 'numeric'
            },
            {
              data: 'far_or_height',
              type: "checkbox",
              className: "htCenter"
            },
            {
              data: 'acres_within_zone',
              editor: false
            },
            {
              data: 'acres_excluded',
              editor: false
            },
            {
              data: 'zn_code_url',
              renderer: 'html'
            },
            {
              data: 'last_edited',
              type: 'date',
              dateFormat: 'MM/DD/YYYY',
              correctFormat: true,
              defaultDate: '01/01/1900',
              // datePicker additional options
              // (see https://github.com/dbushell/Pikaday#configuration)
              datePickerConfig: {
                // First day of the week (0: Sunday, 1: Monday, etc)
                firstDay: 0,
                showWeekNumber: true,
                disableDayFn(date) {
                  // Disable Sunday and Saturday
                  return date.getDay() === 0 || date.getDay() === 6;
                }
              }
            },
            {
              data: 'editor_id',
              editor: false
            },


          ],
          hiddenColumns: {
            // specify columns hidden by default
            columns: [0, 1, 2],
            indicators: true
          },
          minSpareRows: 1,
          licenseKey: 'non-commercial-and-evaluation',
          readOnly: !!$scope.formReadOnly,
      readOnlyCellClassName: 'htDimmed',
          afterValidate(isValid, value, row, prop, source) {
            // $scope.pendingChanges = true;
            // $scope.$apply();
            // $scope.beforeSave('2d20b4d9-f88c-5b22-8832-63ddb377ebe2');
          },
        });
        $scope.hot.addHook("afterChange", function (changes, source) {

          if (changes && source !== 'UndoRedo.undo') {
            changes.forEach(([row, prop, oldValue, newValue]) => {
              if (newValue === '') {
                newValue = null
              }
              var handsonUpdate = $scope.hot.getDataAtRow(row);
              $scope.updateData.push({
                rec_id: handsonUpdate[0],
                zn_recid: handsonUpdate[1],
                [prop]: newValue,
                [`${prop}_old`]: oldValue
              });
            });
            $scope.beforeSave()
          }

        });
      }
      $scope.$watch('formReadOnly', function (newVal) {
  if ($scope.hot) {
    $scope.hot.updateSettings({
      readOnly: !!newVal
    });
    $scope.hot.render();
  }
});
    }

    // Export to CSV 
    $scope.exportToCSV = function () {
      // Get the data from the Handsontable instance
      const data = $scope.hot.getData();

      // Create a CSV string using a simple loop
      let csv = '';
      const headers = ['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows Residential', 'Min DUA', 'Max DUA', 'Calculated Using FAR or Height', 'Acres Within Zone', 'Acres of Existing Dwelling Units Excluded', 'Documentation', 'Last Edited', 'Editor'];

      // Add header row
      csv += headers.join(',') + '\n';

      // Add data rows
      data.forEach(row => {
        csv += row.join(',') + '\n';
      });

      // Prompt the user for a filename
      const filename = prompt("Enter a filename for the CSV file:", "zoning_data.csv");

      // If the user cancels, do nothing
      if (filename === null) {
        return;
      }

      // Create a hidden link element
      const link = document.createElement('a');
      link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      link.download = filename;

      // Trigger a click event on the link to download the CSV file
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };




    /**
      * Update station area dropdown based on jurisdiction selected
      * @param {*} jurisdiction 
      */
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for the sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      $scope.getZoningCodes(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {
          $scope.stationAreas = response.data;

          // Set currentSelectedStationId based on sta_recid if it exists
          if (staRecId) {
            $scope.currentSelectedStationId = staRecId; // Set from URL parameter
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation(); // Fallback
          }

          // Call getStationbyID() after setting the currentSelectedStationId
          $scope.getStationbyID();
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    };


    $scope.getStationbyID = function () {
      $scope.pendingAverages = false;
      lookup.setCurrentStation($scope.currentSelectedStationId);
      $scope.loading = true;
      $scope.loadingTable = true;
      setTimeout(function () {
        fetch.getItem(`api/data/density/averages/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
          .then(response => {
            $scope.currentStation = response.data[0];
            $scope.loading = false;
            $scope.getSubmissionStatus($scope.currentSelectedStationId);
            $scope.getZoningCodesByParcel($scope.currentSelectedStationId);

            // Call the overrideTierForSpecificCorridors function
            $scope.overrideTierForSpecificCorridors($scope.currentStation);

            if ($scope.currentStation && $scope.currentStation.service_tier) {
              var tier = $scope.currentStation.service_tier.toString();
              $scope.complianceThresholds = (_.filter($scope.thresholds, { 'tier': tier }))[0].threshold;
            }

            vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
          
            return $scope.getCurrentDensityPolicy($scope.policy_name);
          }
          )
          .catch(err => {
            console.log(err);
            if (err.status === 403) {
              $state.go('login');
            }
          })
      }, 2000)
    }

    $scope.getSubmissionStatus = function (station) {
      if (!$scope.currentSelectedStationId) {
        $scope.currentSelectedStationId = station;
      }
      
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Density')
        .then(response => {
          $scope.stationStatus = response.data;
          const minDUAResult = _.filter($scope.stationStatus, { submission_policy_name: 'Minimum Density Residential', submitted: true });
          $scope.minDUA = minDUAResult.length > 0;

          const maxDUAResult = _.filter($scope.stationStatus, { submission_policy_name: 'Maximum Density Residential', submitted: true });
          $scope.maxDUA = maxDUAResult.length > 0;

          // Check for Residential Uses
          const residentialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Residential Uses Data Verification', submitted: true });
          if (residentialUses.length > 0) {
            residentialUses.forEach(element => {
              if (element.submitted === true) {
                $scope.residentialUsesCheck = true;
              }
            });
          }
    
          // Check for Commercial Uses
          const commercialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Commercial Office Uses', submitted: true });
          if (commercialUses.length > 0) {
            commercialUses.forEach(element => {
              if (element.submitted === true) {
                $scope.commercialUsesCheck = true;
              }
            });
          }
          
          $scope.submitted = $scope.minDUA || $scope.maxDUA || $scope.residentialUsesCheck || $scope.commercialUsesCheck;
          
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    }

    /**
  * @function overrideTierForSpecificCorridors
  * @description Overrides the service_tier for specific corridors
  * @param {object} currentStation The current station object
  * @returns {number} The overridden service_tier or the original service_tier
  */

    $scope.overrideTierForSpecificCorridors = function (currentStation) {
      console.log(currentStation);
      if (currentStation) {
        if ($scope.tier4Corridors.includes($scope.currentStation.station_name)) {
          $scope.showTierOverride = true;
          // Override service_tier to 4
          currentStation.service_tier = 4;

          // Apply Tier 4 thresholds
          $scope.complianceThresholds = _.filter($scope.thresholds, { 'tier': '4' })[0].threshold;
          $scope.complianceThresholdsTier3 = _.filter($scope.thresholds, { 'tier': '3' })[0].threshold;
          // Update Compliance thresholds for commercial density to be the same as tier 3 
          $scope.complianceThresholds.toc_min_far = $scope.complianceThresholdsTier3.toc_min_far;
          $scope.complianceThresholds.toc_max_far = $scope.complianceThresholdsTier3.toc_max_far;
        }
        else {
          $scope.showTierOverride = false;
        }
      }
    }.bind(this);


    $scope.getZoningCodesByParcel = function (station) {
      fetch.getAllItems(`api/data/density/zoningcodes/${$scope.densityType}/${$scope.currentJurisdiction}/${encodeURIComponent(station)}`, $scope.znCodes)
        .then(response => {

          // Update zoning codes with lot area sizes
          $scope.znCodes.forEach(element => {
            var znCodeAreaInclude = _.filter(response.data, { zn_code: element.zn_code, exclude: false })[0];
            if (znCodeAreaInclude && znCodeAreaInclude.total_gisacre) {
              element.acres_within_zone = parseFloat(znCodeAreaInclude.total_gisacre).toFixed(2);
            }

            var znCodeAreaExclude = _.filter(response.data, { zn_code: element.zn_code, exclude: true })[0];
            if (znCodeAreaExclude && znCodeAreaExclude.total_gisacre) {
              element.acres_excluded = parseFloat(znCodeAreaExclude.total_gisacre).toFixed(2);
            }
          });

          // Identify highlighted zn_codes
          var highlightedZnCodes = new Set(response.data.map(item => item.zn_code));

          // Separate highlighted and non-highlighted rows
          const highlightedRows = [];
          const nonHighlightedRows = [];

          $scope.znCodes.forEach(row => {
            if (highlightedZnCodes.has(row.zn_code)) {
              highlightedRows.push(row);
            } else {
              nonHighlightedRows.push(row);
            }
          });

          // Combine highlighted rows and non-highlighted rows
          const sortedZnCodes = highlightedRows.concat(nonHighlightedRows);

          // Update handsontable with sorted data
          $scope.hot.updateSettings({
            data: sortedZnCodes, // Update with the sorted data
            cells: function (row, col) {
              var cellProperties = {};
              var znCode = $scope.hot.getDataAtCell(row, 3); // Assuming zn_code is in column index 3

              if (highlightedZnCodes.has(znCode)) {
                if (col === 5 || col === 8) {
                  cellProperties.className = 'highlightRow htCenter';
                } else {
                  cellProperties.className = 'highlightRow';
                }
              }

              return cellProperties;
            }
          });

          $scope.loadingTable = false;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    }


    // File upload functions 

// $scope.initializeField = function (fieldId) {
//   if (!$scope.attachmentData[fieldId]) {
//     $scope.attachmentData[fieldId] = {
//       fileName: null,
//       file: null,
//       isFileSelected: false
//     };
//   }
// };

// Function to open the file dialog
// $scope.openFileDialog = function (fieldId) {
//   console.log(fieldId)
//   $timeout(function () {
//     document.getElementById('fileInput' + fieldId).click();
//   }, 0);
// };

// Function to handle file changes
// $scope.fileChanged = function (fieldId, element) {
//   console.log(fieldId);
//   console.log(element);
//   $scope.initializeField(fieldId);  // Ensure field is initialized

//   var file = element.files[0];
//   if (file) {
//     // Check if the file type is PDF, Word document, or Excel file
//     if (
//       file.type !== 'application/pdf' &&
//       file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
//       file.type !== 'application/msword' && // For .doc
//       file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
//       file.type !== 'application/vnd.ms-excel' // For .xls
//     ) {
//       alert('Please select a PDF, Word document, or Excel file.');
//       element.value = ''; // Reset input to clear the wrong file type
//       return;
//     }

//     $scope.attachmentData[fieldId].fileName = file.name;
//     $scope.attachmentData[fieldId].file = file;
//     $scope.attachmentData[fieldId].isFileSelected = true;

//     $scope.$apply();
//   }
// };
$scope.selectedFile = null;

$scope.handleFileSelect = function(element) {
  console.log(element);
  $scope.setPending();
  $scope.$apply(function() {
      $scope.selectedFile = element.files[0];
  });
};

$scope.uploadFile = function(ngmodelfile) {
  var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
  console.log(ngmodel);
  
  // Use the stored selectedFile instead of getting it from DOM
  var file = $scope.selectedFile;

  if (!file) {
      console.error('No file selected');
      return;
  }

  $scope[`fileUploading_${ngmodelfile}`] = true;

  var fileUpload = {
      fileName: file.name,
      fileType: file.type
  };

  // Rest of your upload logic remains the same
  fetch.updateItem('api/data/get-signed-url', fileUpload)
      .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);

          return $http({
              method: 'PUT',
              url: response.data.signedUrl,
              data: file,
              headers: {
                  'Content-Type': file.type,
              }
          })
          .then(() => {
              $scope.currentDensityPolicy[ngmodel] = response.data.publicUrl;
              return response.data.publicUrl;
          });
      })
      .then(publicUrl => {
          console.log('Upload successful');
          console.log('Public URL:', publicUrl);

          $scope[`fileUploading_${ngmodelfile}`] = false;
          $scope[`${ngmodelfile}`] = '';
          $scope.clearFile(ngmodelfile);
          $scope.uploadSuccess = true;
          $scope.selectedFile = null; // Clear the selected file
      })
      .catch(error => {
          console.error('Error:', error);
          alert('Upload failed');
          $scope[`fileUploading_${ngmodelfile}`] = false;
      });
};

$scope.clearFile = function(ngmodelfile) {
  const fileInput = document.getElementById(ngmodelfile);
  if (fileInput) {
      fileInput.value = '';
      $scope.selectedFile = null;
  }
};

$scope.checkSubstring = function (input) {
return input && input.length >= 4 && input.substring(0, 4) === 'http';
};

$scope.removeFile = function(ngmodel) {
console.log(ngmodel);
  $scope.currentDensityPolicy[ngmodel] = '';
  $scope.setPending();
  $scope.savemode = 'validation';
  $scope.pendingChanges = true;
};


// End file upload functions 
        

    $scope.getCurrentDensityPolicy = function (policy_name) {
     
      if (policy_name) {
      $scope.policy_name = policy_name;
    }
    console.log('policy_name:', policy_name);

    fetch.getAllItems(`api/data/getDensityForm/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${encodeURIComponent($scope.policy_name)}`)
      .then(response => {
      
        
        if (response.data && response.data.length > 0) {
          $scope.currentDensityPolicy = response.data[0];
          $scope.initialLoad = false;
        console.log('density_form_id:', $scope.currentDensityPolicy.density_form_id);
        if(policy_name === 'Residential Uses Data Verification'){
          if($scope.residential_density_no_changes_checked){
            $scope.residential_density_no_changes_checked = true;
          }
          if($scope.residential_density_table_changes_checked){
            $scope.residential_density_table_changes_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_equivalency_table){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_equivalency_table){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_exclude_parcels){
            $scope.residential_density_exclude_parcels_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_adopted_plan){
            $scope.residential_density_adopted_plan_checked = true;
          }
          if($scope.currentDensityPolicy.residential_exclude_parcels_additional_details){
            $scope.residential_density_exclude_parcels_checked = true;
          }
          if($scope.currentDensityPolicy.residential_equivalency_table_additional_details){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_adopted_plan_additional_details){
            $scope.residential_density_adopted_plan_checked = true;
          }  
        }
          if(policy_name === 'Commercial Office Uses Data Verification'){
            if($scope.currentDensityPolicy.commercial_density_equivalency_table){
              $scope.commercial_density_equivalency_table_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_density_adopted_plan){
              $scope.commercial_density_adopted_plan_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_density_exclude_parcels){
              $scope.commercial_density_exclude_parcels_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_exclude_parcels_additional_details){
              $scope.commercial_density_exclude_parcels_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_equivalency_table_additional_details){
              $scope.commercial_density_equivalency_table_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_adopted_plan_additional_details){
              $scope.commercial_density_adopted_plan_checked = true;
            }
        }
        $scope.initialLoad = false;
        console.log($scope.initialLoad);
      }
    })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })

  }

    $scope.updateCurrentDensityPolicy = function () {

      $scope.formSubmitted = true;
      if (densityForm.$invalid) {
        $scope.saving = false;
        return;
      }

        // Ensure cleared fields send `null` instead of empty strings or undefined values
        Object.keys($scope.currentDensityPolicy).forEach(key => {
          if ($scope.currentDensityPolicy[key] === "" || $scope.currentDensityPolicy[key] === undefined) {
            $scope.currentDensityPolicy[key] = null;
          }
        });

      console.log("Payload being sent:", $scope.currentDensityPolicy);
      fetch.updateItem(`api/data/density/forms/update`, $scope.currentDensityPolicy)
      .then(response => {
        $scope.saving = false;
        $scope.saved = true;
        
        $scope.pendingChanges = false;
        setTimeout(() => {
          // $scope.submitmode = null;
          $scope.saved = false;
          $scope.savemode = null;
          $scope.successMessage = null;
          $scope.$apply();
        }, 4000);
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    // $scope.submitDensity = function () {
    //   console.log($scope.density.residentialUsesCheck);
    //   $scope.formSubmitted = true;
    //   $scope.saving = true;
    //   var upsertData = []; // Initialize upsertData array

    //   $scope.upsertData = []; // Reset or initialize upsert data array

    //   console.log("submissing", $scope.density.residentialUsesCheck, $scope.residentialUses.length)
    //   if ($scope.density.residentialUsesCheck && $scope.residentialUses.length > 0) {
    //     $scope.residentialUses.forEach(element => {
    //       if (!element.submitted) {
    //         element.submitted = true;
    //         upsertData.push({
    //           submission_id: element.submission_id,
    //           density_residential_uses: true,
    //           submitted: true,
    //         })
    //       }
    //     });
    //   }

    //   if ($scope.density.commercialUsesCheck && $scope.commercialUses.length > 0) {
    //     $scope.commercialUses.forEach(element => {
    //       if (!element.submitted) {
    //         element.submitted = true;
    //         upsertData.push({
    //           submission_id: element.submission_id,
    //           density_commercial_offices_uses: true,
    //           submitted: true,
    //         })
    //       }
    //     });
    //   }

    //   fetch.updateItem('api/data/submissions/update', upsertData)
    //     .then(response => {
          
    //       $scope.saving = false;
    //       $scope.submissions = [];
    //       $scope.saved = true;
    //       $scope.pendingChanges = false;
    //       setTimeout(() => {
    //         $scope.submitmode = null;
    //         $scope.saved = false;
    //         $scope.$apply();
    //       }, 2000);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if(err.status === 403){
    //         $state.go('login');
    //       }
    //     })
    // }

    /**
    * Function to save validation information for residential zoning
    * Variable definitions
    * saving (true/false)           : Flag to show saving messages and icons e.g., fa-cog spin
    * saved (true/false)            : Flag showing saved messages and icons
    * saveType                      : Text showing on save button
    * currentStation                : Currently selected station area
    * Fn getStationbyId             : Function retrieving weighted averages for density
    * setTimeout                    : Function for how long saved messages show. Set to 3 seconds
    */
    $scope.saveZoningCodes = function () {
      $scope.saving = true;
      $scope.upsertData = _.filter($scope.stationStatus, function (o) {
        if (o.policy === 'Minimum Density Residential' || o.policy === 'Maximum Density Residential') {
          return o
        }
      });

      fetch.updateItem(`api/data/submissions/update`, $scope.upsertData)
        .then(response => {
          
          $scope.saved = true;
          $scope.saving = false;
          $scope.success = true;
          $scope.getStationbyID();
          setTimeout(() => {
            $scope.success = false;
            $scope.savemode = null;
            $scope.saved = false;
            $scope.successMessage = null;
            $scope.$apply();
          }, 10000);
        })
        .catch(err => {
          console.log(err);
        })
    }

    // $scope.checkValidation = function () {
    //   $scope.savemode = 'validation';
    // }

    $scope.deleteZoningCodes = function () {
      $scope.saving = true;
      // iterate through znCodes and if selected add to updateData 
      $scope.updateData = [];
      $scope.znCodes.forEach(element => {
        if (element.selected) {
          $scope.updateData.push(element);
        }
      });
      $scope.saving = true;
      fetch.updateItem(`api/data/density/zoning/delete`, $scope.updateData)
        .then(response => {

          $scope.znCodes = _.filter($scope.znCodes, function (o) {
            return !o.selected && o.zn_recid !== null
          })
          $scope.saving = false;
          $scope.updateData = [];
          $scope.hot.loadData($scope.znCodes);
          $('#deleteZoningCodeModal').modal('toggle');
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.addZoningCode = function () {
      $scope.saving = true;
      console.log($scope.addCode);
      $scope.addCode.rec_id = lookup.getUUID();
      if ($scope.jurisdictionDetail) {
        $scope.addCode.jurisdiction_id = $scope.jurisdictionDetail.jurisdiction_id;
        $scope.addCode.county_id = $scope.jurisdictionDetail.county_id;
      }

      $scope.addCode.zn_recid = `${$scope.currentJurisdiction}-${$scope.addCode.zn_code}`;
      // Update allows residential and allows commercial to be 1/0 if true/false 

      // Set TOC values to be the same as zn min/max values 
      if ($scope.addCode.zn_min_dua || $scope.addCode.zn_min_dua === 0) {
        $scope.addCode.toc_min_dua = $scope.addCode.zn_min_dua;
      } else {
        $scope.addCode.toc_min_dua = null;
        $scope.addCode.zn_min_dua = null;
      }
      if ($scope.addCode.zn_max_dua || $scope.addCode.zn_max_dua === 0) {
        $scope.addCode.toc_max_dua = $scope.addCode.zn_max_dua;
      } else {
        $scope.addCode.toc_max_dua = null;
        $scope.addCode.zn_max_dua = null;
      }
      if ($scope.addCode.zn_min_far || $scope.addCode.zn_min_far === 0) {
        $scope.addCode.toc_min_far = $scope.addCode.zn_min_far;
      } else {
        $scope.addCode.toc_min_far = null;
        $scope.addCode.zn_min_far = null;
      }
      if ($scope.addCode.zn_max_far || $scope.addCode.zn_max_far === 0) {
        $scope.addCode.toc_max_far = $scope.addCode.zn_max_far;
      } else {
        $scope.addCode.toc_max_far = null;
        $scope.addCode.zn_max_far = null;
      }
      if (!$scope.addCode.allows_residential) {
        $scope.addCode.allows_residential = null;
      }
      if (!$scope.addCode.allows_residential) {
        $scope.addCode.allows_residential = null;
      }
      if (!$scope.addCode.allows_comm_office) {
        $scope.addCode.allows_comm_office = null;
      }
      if (!$scope.addCode.zn_code_url) {
        $scope.addCode.zn_code_url = null;
      }




      fetch.createItem(`api/data/density/zoning/create`, $scope.addCode)
        .then(response => {
          $scope.saved = true;
          $scope.saving = false;
          $scope.success = true;
          // Find the correct index to insert the new zoning code alphabetically
          const index = $scope.znCodes.findIndex(code => code.zn_code > $scope.addCode.zn_code);

          // Insert the new code at the correct index, or at the end if no index is found
          if (index > -1) {
            $scope.znCodes.splice(index, 0, $scope.addCode);
          } else {
            $scope.znCodes.push($scope.addCode);
          }
          //Load updated data into table
          $scope.hot.loadData($scope.znCodes);
          //Re-order highlighted zoning codes
          $scope.getZoningCodesByParcel($scope.currentSelectedStationId);
          //Reset variables
          $scope.addCode = {};

          // Success response
          console.log('Success:', response);
          $scope.notificationMessage = ''; // Clear any previous notification

          // Close add zoning code modal 
          $('#addZoningCodeModal').modal('toggle');
        })
        .catch(error => {
          if (error.status === 403) {
            $state.go('login');
          }
          if (error.data && error.data.message && error.data.message.includes("duplicate key value violates unique constraint")) {
            console.log("This zoning code already exists");
            $scope.notificationMessage = `The zoning code ${$scope.addCode.zn_code} already exists in the table!`;
          } else {
            console.log("An error occurred:", error);
            $scope.notificationMessage = "An error occurred: " + (error.data && error.data.message ? error.data.message : 'Unknown error');
          }
          $scope.saving = false;
          $scope.addCode = {};

          // Clear the notification after 5 seconds
          $timeout(function () {
            $scope.notificationMessage = '';
          }, 5000); // 5000ms = 5 seconds

        })
    }

    $scope.getJurisdictionDetail = function () {
      if ($scope.currentJurisdiction) {
        fetch.getItem(`api/data/jurisdiction/detail`, encodeURIComponent($scope.currentJurisdiction))
          .then(response => {
            $scope.jurisdictionDetail = response.data[0];
          })
          .catch(err => {
            console.log(err);
            if (err.status === 403) {
              $state.go('login');
            }
          })
      }
    }

  }
  $onInit() {
    // this.$scope.loading = true;
    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        // this.$scope.submitResidential = false;
        // this.$scope.submissionList = ['Average Minimum Residential DUA', 'Average Maximum Residential DUA']
        // this.$scope.currentDensityPolicy = {};
        return this.getJurisdictionList();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })

  }
  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }
        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
        this.$scope.getZoningCodes(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
           this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);
          this.lookup.setSubmissionPolicies(this.$scope.submissionSummary);
         
          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Compliant' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Compliant' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Compliant' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Compliant' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }







}

export default angular.module('appApp.residential_uses', [uiRouter])
  .config(routes)
  .component('residentialUses', {
    template: require('./residential_uses.html'),
    controller: ResidentialUsesComponent,
    controllerAs: 'residentialUsesCtrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/account/density/residential_uses/residential_uses.component.js